<div class="train-data-panel-top">
	<div class="ptc-content text-center">
		<label> {{trainLabel.trainPTC}}: </label>
		<p>{{ptcTrainIndicator}}</p>
	</div>
</div>